import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetRecoilCorporateApprovedList } from "../../store/corporateApproveList";

function CorporateAppScroll({ onSelection, viewItemDetails }) {
  const { corporate_id } = useParams();
  const corporateData = GetRecoilCorporateApprovedList();

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (corporateData?.Corporate_Info) {
      const mapped = corporateData.Corporate_Info.map((ele) => ({
        ...ele,
        checked: false,
      }));
      setTableData(mapped);
    }
  }, [corporateData?.Corporate_Info]);

  const handleCheckboxChange = (e, index) => {
    const updated = [...tableData];
    updated[index] = { ...updated[index], checked: e.target.checked };
    setTableData(updated);
    onSelection?.(updated);
  };

  const statusBadge = (statusId, statusName) => {
    const styles = {
      1: "bg-emerald-100 text-emerald-800 border-emerald-200",
      2: "bg-rose-100 text-rose-800 border-rose-200",
      3: "bg-amber-100 text-amber-800 border-amber-200",
      4: "bg-blue-100 text-blue-800 border-blue-200",
      5: "bg-purple-100 text-purple-800 border-purple-200",
      6: "bg-gray-100 text-gray-700 border-gray-200",
    };

    return (
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
          styles[statusId] || "bg-gray-100 text-gray-700 border-gray-200"
        }`}
      >
        {statusName || "Unknown"}
      </span>
    );
  };

  return (
    <div className="h-[calc(100vh-140px)] bg-white rounded-xl border shadow-sm overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-gray-50 border-b px-4 py-3">
        <h3 className="text-sm font-semibold text-gray-700">
          Corporate Approvals ({tableData.length})
        </h3>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50 hover:scrollbar-thumb-gray-400 transition-colors">
        {tableData.length === 0 ? (
          <div className="h-full flex items-center justify-center text-gray-500 text-sm p-4 text-center">
            No corporate approval requests found
          </div>
        ) : (
          tableData.map((corp, index) => {
            const isActive = Number(corporate_id) === corp?.Corporate_Id;

            return (
              <div
                key={corp.Corporate_Id || index}
                onClick={() => viewItemDetails(corp?.Corporate_Id)}
                className={`
                  group border-b last:border-b-0 px-4 py-3.5 cursor-pointer
                  transition-colors duration-150
                  hover:bg-indigo-50/40
                  ${isActive ? "bg-indigo-50 border-l-4 border-l-indigo-500" : ""}
                `}
              >
                <div className="flex items-start gap-3">
                  {/* Optional checkbox – uncomment if bulk actions are needed */}
                  {/* <div className="flex-shrink-0 pt-1">
                    <input
                      type="checkbox"
                      checked={corp.checked || false}
                      onChange={(e) => handleCheckboxChange(e, index)}
                      onClick={(e) => e.stopPropagation()}
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                  </div> */}

                  {/* Main content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <p className="text-sm font-semibold text-gray-900 line-clamp-2">
                        {corp?.Corporate_Name || "Unnamed Corporate"}
                      </p>
                    </div>

                    <div className="mt-1.5 space-y-1 text-xs text-gray-600">
                      <p className="truncate">{corp?.Corporate_Email_Address || "—"}</p>
                      <p>{corp?.Corporate_Contact_Person_Mobile || "—"}</p>
                    </div>

                    <div className="mt-2.5">
                      {statusBadge(corp?.Corporate_Approval_Status_Id, corp?.Corporate_Approval_Status_Name)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Footer with count */}
      {tableData.length > 0 && (
        <div className="px-4 py-2.5 bg-gray-50 border-t text-xs text-gray-500 flex justify-between items-center">
          <span>
            {tableData.length} {tableData.length === 1 ? "item" : "items"}
          </span>
          <span className="text-gray-400">Click to view details</span>
        </div>
      )}
    </div>
  );
}

export default CorporateAppScroll;